// After a deploy, an open tab can still request page chunks that no longer exist.
// Navigation then fails silently, so reload once at the target URL to fetch the new build.
const RELOAD_KEY = 'chunk-reload-target'

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk [\w-]+ failed/i,
  /Loading CSS chunk [\w-]+ failed/i,
]

export function isChunkLoadError(error) {
  if (!error) return false
  if (error.name === 'ChunkLoadError') return true
  const message = String(error.message || error)
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

/** Returns true when a reload was started; false if this target was already retried. */
export function reloadForChunkError(targetPath, { storage = window.sessionStorage, location = window.location } = {}) {
  const target = String(targetPath || location.pathname || '/')
  if (storage.getItem(RELOAD_KEY) === target) {
    storage.removeItem(RELOAD_KEY)
    return false
  }
  storage.setItem(RELOAD_KEY, target)
  location.assign(target)
  return true
}

export function clearChunkReloadMarker(storage = window.sessionStorage) {
  storage.removeItem(RELOAD_KEY)
}
